import { IconsProps } from './IconsProps';

const Instagram = ({
  className = '',
  viewBox = '0 0 40 40',
  width = 40,
  height = 40,
  onClick,
  svgFill = 'currentColor',
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label="Instagram"
    >
      <g clipPath="url(#clip0_940_86)">
        <path d="M20 40C8.97254 40 0 31.0291 0 20C0 8.97087 8.97254 0 20 0C31.0275 0 40 8.97254 40 20C40 31.0275 31.0275 40 20 40ZM20 2.00317C10.076 2.00317 2.00317 10.076 2.00317 20C2.00317 29.924 10.076 37.9968 20 37.9968C29.924 37.9968 37.9968 29.924 37.9968 20C37.9968 10.076 29.924 2.00317 20 2.00317Z" />
        <path d="M26.0163 30.6119H13.9839C11.4916 30.6119 9.46509 28.6304 9.46509 26.1965V13.8069C9.46509 11.3714 11.4916 9.3916 13.9839 9.3916H26.0163C28.5086 9.3916 30.5351 11.3731 30.5351 13.8069V26.1965C30.5351 28.6321 28.5086 30.6119 26.0163 30.6119ZM13.9839 11.2095C12.4949 11.2095 11.283 12.3747 11.283 13.8069V26.1965C11.283 27.6288 12.4949 28.794 13.9839 28.794H26.0163C27.5053 28.794 28.7156 27.6288 28.7156 26.1965V13.8069C28.7156 12.3747 27.5037 11.2095 26.0163 11.2095H13.9839Z" />
        <path d="M20 25.5087C16.9635 25.5087 14.4929 23.0381 14.4929 19.9999C14.4929 16.9618 16.9635 14.4912 20 14.4912C23.0364 14.4912 25.5087 16.9618 25.5087 19.9999C25.5087 23.0381 23.0381 25.5087 20 25.5087ZM20 16.3124C17.9651 16.3124 16.3108 17.9667 16.3108 20.0016C16.3108 22.0365 17.9651 23.6908 20 23.6908C22.0349 23.6908 23.6891 22.0365 23.6891 20.0016C23.6891 17.9667 22.0349 16.3124 20 16.3124Z" />
        <path d="M27.1997 14.216C27.1997 14.9271 26.6238 15.5047 25.911 15.5047C25.1982 15.5047 24.6223 14.9271 24.6223 14.216C24.6223 13.5048 25.1982 12.9272 25.911 12.9272C26.6238 12.9272 27.1997 13.5048 27.1997 14.216Z" />
      </g>
      <defs>
        <clipPath id="clip0_940_86">
          <rect width="40" height="40" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Instagram;
